module.exports = __webpack_public_path__ + "img/female_business.ebc96e5a.svg";